module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.1 18.4H1.5l9.7-14.8h11.6z","fill":"#aaa"}}),_c('path',{attrs:{"d":"M18.8 18.4H7.2l9.7-14.8h11.6z","fill":"#aaa"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/tab_shading.svg
// module id = 721
// module chunks = 2